export function edit (state, club) {
	const clubIndex = state.clubs.findIndex(c => c.id === club.id);

	state.clubs[clubIndex] = {
		...state.clubs[clubIndex],
		...club
	};
}
